import { useCallback } from "react";
import { Colors } from "../../utils/colors";
import StandardBorderedContainer from "../Containers/StandardBorderedContainer";
import { Icon } from "@iconify/react";
import RectangleButton from "../Buttons/RectangleButton";
import { Event, EventType } from "@markit/common.types";
import { normalizeUrlWithHttps } from "@markit/common.utils";

type LinkedEventPanelProps = {
  event: Event;
};

// Show on Linked Event Dashboard instead of the guest list panel
export const LinkedEventPanel = (props: LinkedEventPanelProps) => {
  const { event } = props;

  const styles = {
    optionsContainer: {
      backgroundColor: Colors.WHITE,
      padding: 24,
    },
  };

  const visitLinkedEvent = useCallback(() => {
    window.open(normalizeUrlWithHttps(event.externalLink), "_blank");
  }, [event.externalLink]);

  return (
    <StandardBorderedContainer containerStyles={styles.optionsContainer}>
      <div className="AlignedRowSpaced">
        <div className="ColumnNormal" style={{ gap: 24 }}>
          <div className="ColumnNormal" style={{ gap: 14 }}>
            <span style={{ fontWeight: 500, fontSize: 20 }}>
              Synced Linked Event
            </span>
            <span className="bodySubtext">
              This is a linked event
              {event.eventType === EventType.EXTERNAL_DATA
                ? " with data collection managed through the Markit API"
                : ""}
              . View this event on the external platform.
            </span>
          </div>
          <div>
            <RectangleButton
              buttonLabel="Visit Linked Event"
              onPress={visitLinkedEvent}
              altPaddingHorz={24}
              altPaddingVert={14}
              altBorderRadius={12}
              iconRight={
                <Icon
                  icon="ion:arrow-forward"
                  height={15}
                  style={{
                    color: Colors.WHITE,
                    transform: "rotateY(0deg) rotate(-45deg)",
                  }}
                />
              }
              altColor={Colors.BLACK}
              altTextColor={Colors.WHITE}
              containerStyles={{ width: "fit-content" }}
            />
          </div>
        </div>
        <div
          className="Centering"
          style={{
            width: 100,
            height: 100,
            borderRadius: 20,
            padding: 14,
            backgroundColor: Colors.WHITE1,
            border: `0.5px solid ${Colors.GRAY2}`,
          }}
        >
          <Icon
            icon="mdi:vector-link"
            height={64}
            style={{ color: Colors.BLUE5 }}
          />
        </div>
      </div>
    </StandardBorderedContainer>
  );
};
